customElements.get('next-drop-signup') || customElements.define('next-drop-signup', class extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('.js-next-drop-signup-input');
    this.submitButton = this.querySelector('.js-next-drop-signup-submit');
    this.message = this.querySelector('.js-next-drop-signup-message');
    this.isSubmitting = false;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    if (this.form) this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.isSubmitting || !this.input) return;

    if (!this.input.checkValidity()) {
      this.input.reportValidity();
      return;
    }

    const email = this.input.value.trim();

    this.setLoading(true);

    this.subscribe(email)
      .then((response) => {
        if (response && response.ok) {
          this.setSuccess();
        } else {
          this.setError();
        }
      })
      .catch(() => {
        this.setError();
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  subscribe(email) {
    const listId = this.dataset.listId;
    const customSource = this.dataset.customSource || 'Miniverse Next Drop';

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=MBx8BT', {
      method: 'POST',
      headers: { revision: '2023-09-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email
                },
                properties: {
                  'Accepts Marketing': 'True'
                },
                meta: {
                  patch_properties: {
                    append: {
                      'Accepts Marketing': 'True'
                    }
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    });
  }

  setLoading(isLoading) {
    this.isSubmitting = isLoading;

    if (this.submitButton) this.submitButton.disabled = isLoading;

    this.classList.toggle('next-drop-hero__signup--loading', isLoading);

    if (isLoading) {
      this.classList.remove('next-drop-hero__signup--success', 'next-drop-hero__signup--error');
      if (this.message) this.message.textContent = 'Submitting\u2026';
    }
  }

  setSuccess() {
    this.classList.remove('next-drop-hero__signup--error');
    this.classList.add('next-drop-hero__signup--success');

    if (this.message) {
      this.message.textContent = "You're on the list! Watch your inbox for first looks.";
    }

    if (this.form) this.form.reset();

    this.focusMessage();
  }

  setError() {
    this.classList.remove('next-drop-hero__signup--success');
    this.classList.add('next-drop-hero__signup--error');

    if (this.message) {
      this.message.textContent = 'Something went wrong. Please try again.';
    }

    this.focusMessage();
  }

  focusMessage() {
    if (this.message) this.message.focus();
  }
});
